import store, {storage} from '@/store';
import _ from 'lodash';

export function getActiveVoucher() {
  let overallSeconds = getOverallSeconds();
  let voucher = JSON.parse(storage.getItem('activeVoucher'));

  if (voucher !== null && !(_.isEmpty(voucher, 'bountyId') && _.isEmpty(voucher, 'voucherStart'))) {
    let bounty = [...store.state.rewards, ...store.state.sweepstakes].find((b) => b.id === voucher.bountyId);
    const ts = parseInt(voucher.voucherStart);
    const diff = Math.round(+new Date / 1000) - ts;
    const remainingSeconds = overallSeconds - diff;
    return {remainingSeconds, ts, bounty};
  }
  return null;
}


export function getOverallSeconds() {
  return _.get(store.getters.appSettings, 'bounty_redeem_countdown_minutes', 0) * 60 +
          _.get(store.getters.appSettings, 'bounty_redeem_countdown_seconds', 0);
}
